import React, { useEffect } from "react";
import { motion } from "framer-motion";

const animations = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};

const AnimatedPageContainer = ({ children }) => {
  useEffect(() => {
    document.body.classList.add("no-scroll");
    const timer = setTimeout(() => {
      document.body.classList.remove("no-scroll");
    }, 1000); 
    return () => {
      document.body.classList.remove("no-scroll");
      clearTimeout(timer);
    };
  }, []);

  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ width: "100%" }}
    >
      {children}
    </motion.div>
  );
};
export default AnimatedPageContainer;